import { fromJS } from 'immutable';
import { markStoreLoading, markStoreLoaded } from '@/store/storeForStoringStatusOfStores.store';
import { putError } from '@/store/error.store';
import { RestAPI } from '@/util/net.js';
import store from '../../../../store/store';

export const unifiedDealsReducer = (state = fromJS({}), action) => {
  switch (action.type) {
    case 'UNIFIED_DEALS_UPDATE_SELECTED_FIELDS':
      // eslint-disable-next-line
      return state.set('selectedFields', fromJS(action.fields));
    case 'UNIFIED_DEALS_UPDATE_FILTER':
      return state.setIn(['filters', action.filterName], action.value);
    case 'UNIFIED_DEALS_UPDATE_FIELD':
      return state.set(action.field, action.value);
    case 'UNIFIED_DEALS_TEMPLATES_LOADED':
      return state.set('templates', fromJS(action.data));
    case 'UNIFIED_DEALS_SAVE_TEMPLATE_COMPLETED':
      return state.set('templateName', '');
    case 'UNIFIED_DEALS_REPORT_GENERATE_COMPLETED':
      return state.set('data', fromJS(action.data));
    case 'UNIFIED_DEALS_CLEAR_DATA':
      return state.set('data', fromJS([]));
    case 'UNIFIED_DEALS_CLEAR_ALL': {
      const templates = state.get('templates');
      if (templates) {
        return state.clear().set('templates', templates);
      }
      return state.clear();
    }
    default:
      return state;
  }
};

export const generate = (dispatch, dto) => {
  dispatch({ type: 'UNIFIED_DEALS_REPORT_GENERATE_STARTED' });
  markStoreLoading(dispatch);
  return RestAPI.post('/api/report/unifieddeals/', dto)
    .then(
      (data) => {
        dispatch({ type: 'UNIFIED_DEALS_REPORT_GENERATE_COMPLETED', data });
        markStoreLoaded(dispatch);
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'UNIFIED_DEALS_REPORT_GENERATE_FAILED' });
        markStoreLoaded(dispatch);
        return true;
      },
    );
};

export const loadTemplates = (dispatch) => {
  dispatch({ type: 'UNIFIED_DEALS_TEMPLATES_LOADING_STARTED' });
  markStoreLoading(dispatch);
  return RestAPI.get('/api/unifieddeals/presets')
    .then(
      (data) => {
        dispatch({ type: 'UNIFIED_DEALS_TEMPLATES_LOADED', data });
        markStoreLoaded(dispatch);
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'UNIFIED_DEALS_TEMPLATES_LOADING_FAILED' });
        markStoreLoaded(dispatch);
        return true;
      },
    );
};


export const saveTemplate = (dispatch, templateData, editId) => {
  dispatch({ type: 'UNIFIED_DEALS_SAVE_TEMPLATE_STARTED' });
  markStoreLoading(dispatch);
  return RestAPI.post(editId ?
    `/api/unifieddeals/presets/edit/${editId}` :
    '/api/unifieddeals/presets/new', templateData, 'application/json')
    .then(
      (data) => {
        dispatch({ type: 'UNIFIED_DEALS_SAVE_TEMPLATE_COMPLETED', data });
        loadTemplates(dispatch);
        markStoreLoaded(dispatch);
        return true;
      },
    ).catch(
      (data) => {
        if (data.exception == 'javax.naming.NameAlreadyBoundException') {
          // eslint-disable-next-line
          putError(dispatch, { ['Unable to save preset']:
            'preset with current name already exists',
          exception: false });
        } else {
          putError(dispatch, data);
        }
        dispatch({ type: 'UNIFIED_DEALS_SAVE_TEMPLATE_FAILED' });
        markStoreLoaded(dispatch);
        return true;
      },
    );
};

export const deleteTemplate = (dispatch, id) => {
  dispatch({ type: 'UNIFIED_DEALS_TEMPLATE_DELETE_STARTED' });
  markStoreLoading(dispatch);
  return RestAPI.delete(`/api/unifieddeals/presets/delete/${id}`)
    .then(
      (data) => {
        dispatch({ type: 'UNIFIED_DEALS_TEMPLATE_DELETED', data });
        loadTemplates(dispatch);
        markStoreLoaded(dispatch);
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'UNIFIED_DEALS_TEMPLATE_DELETE_FAILED' });
        markStoreLoaded(dispatch);
        return true;
      },
    );
};

function exportPostReport(dispatch, url, data, startAction, completeAction, failAction) {
  dispatch({ type: startAction });
  markStoreLoading(dispatch);
  const req = new XMLHttpRequest();
  req.open('POST', url, true);
  req.responseType = 'arraybuffer';
  req.setRequestHeader('Content-Type', 'application/json');
  req.setRequestHeader('X-CSRF-TOKEN', store.getState().getIn(['session', 'csrf']));
  req.onload = () => {
    const blob = new Blob([req.response], { type: '' });
    const contentDisposition = req.getResponseHeader('Content-Disposition').replace(/"+/g, '');
    const fileNameIdx = contentDisposition.indexOf('filename=');
    const fileName = decodeURI(contentDisposition.substring(fileNameIdx + 9));
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    dispatch({ type: completeAction });
    markStoreLoaded(dispatch);
    return true;
  };
  try {
    req.send(JSON.stringify(data));
    return true;
  } catch (err) {
    putError(dispatch, err.response);
    dispatch({ type: failAction });
    markStoreLoaded(dispatch);
    return true;
  }
}

export const profitLoss = (dispatch, templateData, format) => {
  exportPostReport(dispatch, `/api/report/export/profitloss/${format}`, templateData,
    'UNIFIED_DEALS_PROFIT_LOSS_STARTED',
    'UNIFIED_DEALS_PROFIT_LOSS_COMPLETED', 'UNIFIED_DEALS_PROFIT_LOSS_FAILED');
};

export const download = (dispatch, templateData, format) => {
  exportPostReport(dispatch, `/api/report/export/unifieddeals/${format}`, templateData,
    'UNIFIED_DEALS_DOWNLOAD_STARTED',
    'UNIFIED_DEALS_DOWNLOAD_COMPLETED', 'UNIFIED_DEALS_DOWNLOAD_FAILED');
};

export const clearData = (dispatch) =>
  dispatch({ type: 'UNIFIED_DEALS_CLEAR_DATA' });

export const selectFields = (dispatch, fields) => {
  dispatch({ type: 'UNIFIED_DEALS_UPDATE_SELECTED_FIELDS', fields });
};

export const updateFilterValue = (dispatch, filterName, value) => {
  dispatch({ type: 'UNIFIED_DEALS_UPDATE_FILTER', filterName, value });
};

export const updateFieldValue = (dispatch, field, value) => {
  dispatch({ type: 'UNIFIED_DEALS_UPDATE_FIELD', field, value });
};

export const clear = (dispatch) => dispatch({ type: 'UNIFIED_DEALS_CLEAR_ALL' });
